// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3Mj4o","content":"style_content__1zTxy","header":"style_header__3gd1p","text":"style_text__wbChp"};